module.exports = __webpack_public_path__ + "media/images/competitions/awards_trophy_bgd-02dda4ddb347fd654c7438aade626aeb.png";